<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h4>Choose from the list below and upload your photo.</h4><br>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <h4>Remember, the photo of your document must be:</h4><br>
        <ul>
            <li>Of an authentic and original ID document (not a copy of one)</li>
            <li>Clear and in focus (so that the information on your document is readable)</li>
            <li>In colour</li>
            <li>Unaltered by computer software in any way</li>
        </ul><br>
          <img src="https://images.ctfassets.net/2tjc93jinw29/2Z7j999JEqOayRzamwUUvP/6fa63577cbbf831e8eb635a0bce5a336/ID_Image_Examples.jpg?h=600" alt="" class="responsive">

        <InputRadioGroup
            name="Which_document"
            :required="checkIsRequired('Which_document')"
            :error="formRef.errors.get('Which_document')"
            v-model="formRef.Which_document"
            :options="getField('Which_document').options"
        >
            <template v-slot:question>
                {{ getField("Which_document").question }}
            </template>
        </InputRadioGroup>

        <InputFile
            @fileUpdated="handleFileInput"
            :error="formRef.errors.get('file')"
            accept="image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
        />
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import InputFile from "../Form/InputFile.vue";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})
const whichDocumentDefault = { Which_document: "" }

let formRef = markRaw(ref(new Form({
    ...whichDocumentDefault,
    file: null
}, {...whichDocumentDefault, ...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

function handleFileInput(e) {
    formRef.value.file = e;
}

defineExpose({
    formRef
})
</script>

<style scoped>
.responsive {
  width: 100%;
  height: auto;
  margin-bottom: 10%;
}
</style>
